import { Button, Typography } from "@kitbird/core";
import { Navigate } from "react-router-dom";
import { CardContent, PageCard, PageWrapper } from "../../../../components/Content/Content.style";
import { HeaderText } from "../../../../components/FloatHeader/FloatHeader.style";
import { Stepper, Step } from "../../../../components/Stepper";
import { stepsConfig } from "../utils";
import {
  Step0, Step1, Step2, Step3, Step4, Step5,
} from "./form-steps";
import { FormBusinessTrxProvider } from "../FormBusinessTrxProvider";
import { getIconProps } from "../BusinessTrxProvider";
import ModalConfirmation from "../../../../components/ModalConfirmation";
import { IContextValue } from "../types";

type ICreateEditBusinessTrxProps = Pick<IContextValue, "isEditMode" | "currentTrxFormValues" | "control" | "setValue" | "currentStep" | "setCurrentStep" | "formId" | "onCancelFormClick" | "onSubmitFormClick" | "previousStep" | "modal" | "setModal" | "handleSubmit" | "onFormSubmit" | "onFormError">

const CreateEditBusinessTrx = ({
  isEditMode,
  currentTrxFormValues,
  control,
  setValue,
  currentStep,
  setCurrentStep,
  formId,
  onCancelFormClick,
  onSubmitFormClick,
  previousStep,
  modal,
  setModal,
  handleSubmit,
  onFormSubmit,
  onFormError,
}: ICreateEditBusinessTrxProps) => {
  const stepComponents = [Step0, Step1, Step2, Step3, Step4, Step5];
  const StepComponent = stepComponents[currentStep.idx] || null;

  if (!currentTrxFormValues && isEditMode) return <Navigate to={"/master-data/business-transaction"} />;
  return (
    <PageWrapper>
      <HeaderText>
        <Typography level={3} fontWeight="medium">
          Pendaftaran kode transaksi
        </Typography>
      </HeaderText>
      <PageCard>
        <CardContent style={{ overflow: "hidden" }}>
          <Typography level={4} fontWeight="medium" data-testid="create-edit-business-trx-title">
            {isEditMode ? "Edit" : "Tambah"} data
          </Typography>
          <Stepper
            onClick={(name, idx) => setCurrentStep({ name, idx })}
            backgroundColor="#fff"
            borderRadius="0"
            size="medium"
          >
            {stepsConfig.map((step, idx) => (
              <Step
                dataTestId="step-business-trx"
                key={idx}
                currentIndex={currentStep.idx}
                label={step.label}
                name={step.name}
                stepIndex={idx}
                disableClick
                {...getIconProps(step, isEditMode)}
              />
            ))}
          </Stepper>
          <FormBusinessTrxProvider
            control={control}
            step={currentStep.idx}
            setValue={setValue}
            isEditMode={isEditMode}
          >
            <form id={formId} noValidate>
              {StepComponent ? (
                <StepComponent
                  control={control}
                  setValue={setValue}
                />
              ) : null}
            </form>
          </FormBusinessTrxProvider>
          <div style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "8px",
            marginTop: "auto",
          }}>
            <Button
              variant="text"
              onClick={onCancelFormClick}
            >
              Batalkan
            </Button>
            <Button
              variant="secondary"
              onClick={previousStep}
              disabled={currentStep.idx === 0}
              style={{ minWidth: "170px", display: currentStep.idx === 0 ? "none" : "block" }}
            >
              Sebelumnya
            </Button>
            <Button
              data-testid="submit-button-businessTrx"
              variant="primary"
              onClick={onSubmitFormClick}
              style={{ minWidth: "170px" }}
            >
              {currentStep.idx === stepsConfig.length - 1 ? "Simpan" : "Selanjutnya"}
            </Button>
          </div>
        </CardContent>
      </PageCard>
      {modal === "CONFIRMATION" && (
        <ModalConfirmation
          data-testid="modal-confirmation-business-trx"
          open
          onClose={() => setModal("")}
          title="Konfirmasi simpan data"
          message={`Apakah Anda yakin ingin ${isEditMode ? "menyimpan perubahan ini" : "menambahkan data baru"} di kode transaksi?`}
          action={{
            negativeBtn: {
              label: "Batal",
              onClick: () => setModal(""),
              show: true,
            },
            positiveBtn: {
              label: "Ya, tambahkan",
              destructive: false,
              onClick: () => handleSubmit(onFormSubmit, onFormError)(),
              show: true,
            },
          }}
        />
      )}
    </PageWrapper>
  );
};

export default CreateEditBusinessTrx;
